import { get } from 'lodash'

export function level(user) {
  return get(user, 'level') || 0
}

const levelNames = ['普通会员', '月VIP会员', '年度VIP会员', '终身VIP会员']

export function levelName(user) {
  return levelNames[level(user)]
}

export function expiration(user) {
  const d = get(user, 'expiration')
  return new Date(d ?? 0)
}

export function isExpired(user) {
  return expiration(user) < new Date()
}
